export default "__VITE_ASSET__DWE5zt07__"